import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminPanelService } from '../../../data/admin-panel.service';
import { MiscSnackBarService } from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import { ActivityForEdit } from '../../../data/activityi-for-edit';
import { UserRole } from '../../../../../../../../core/src/lib/login/data/user-role';
import moment from 'moment/moment';

@Component({
  selector: 'app-activity-editor-dialog',
  templateUrl: './activity-editor-dialog.component.html',
  styleUrls: ['./activity-editor-dialog.component.scss']
})
export class ActivityEditorDialogComponent implements OnInit {
  saveLoading = false;
  tempActivity: ActivityForEdit
  allRoles: UserRole[]
  allRolesSting: string[];
  selectedRolesSting: string[];

  tempStartTime: Date
  tempEndTime: Date;

  constructor(
    protected dialogRef: MatDialogRef<ActivityEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      activity: ActivityForEdit,
      allRoles: UserRole[]
    }
  ) {
    this.tempActivity = Object.assign({}, this.data.activity)

    this.allRoles = this.data.allRoles;
    if(this.allRoles) {
      this.allRolesSting = this.allRoles.map((role => role.name));
      this.selectedRolesSting = this.allRolesSting.filter((role => this.tempActivity.roles.includes(role)))
    }
  }

  ngOnInit(): void {

    if(this.tempActivity.startTime) {
      this.tempStartTime = moment(this.tempActivity.startTime, ['h:m a', 'H:m']).toDate()
    }

    if(this.tempActivity.endTime) {
      this.tempEndTime = moment(this.tempActivity.endTime, ['h:m a', 'H:m']).toDate()
    }

    this.tempActivity.color = '#' + this.tempActivity.color
  }

  saveDict() {
    this.saveLoading = true;

    if(this.tempStartTime) {
      this.tempActivity.startTime = moment(this.tempStartTime).format('HH:mm:ss')
    }
    if(this.tempEndTime) {
      this.tempActivity.endTime = moment(this.tempEndTime).format('HH:mm:ss')
    }
    if(this.selectedRolesSting){
      this.tempActivity.roles = this.selectedRolesSting;
    }

    this.tempActivity.color = this.tempActivity.color.substring(1);

    this.adminPanelService.saveActivityCondition(this.tempActivity).subscribe(newDict => {
      this.miscSnackBarService.openSuccessSnackBar('Success!')

      this.dialogRef.close(newDict);
    }, error => {
      this.miscSnackBarService.openErrorSnackBar(error.message)
      this.saveLoading = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }
}
